<template>
  <Watermark :content="watermarkContent">
    <Layout>
      <Header :logo="logo" :title="lang(title)" />
      <Layout>
        <Sider>
          <LayoutMenu />
        </Sider>
        <LayoutContent class="layout-content">
          <Tabs />
          <div class="page-wrap">
            <router-view v-slot="{ Component }">
              <keep-alive :include="VITE_APP_ENV !== 'development' ? keepAliveComponentNames : []">
                <component :is="Component" :key="$route.fullPath"></component>
              </keep-alive>
            </router-view>
          </div>
        </LayoutContent>
      </Layout>
    </Layout>
  </Watermark>
</template>

<script lang="ts" setup>
  import { computed, KeepAlive } from 'vue'
  import dayjs from 'dayjs'
  import { Layout, LayoutContent } from 'ant-design-vue'
  import { Watermark } from '@jms/components'
  import LayoutMenu from './menu/Index.vue'
  import Header from './header/Index.vue'
  import Sider from './sider/Index.vue'
  import Tabs from './tabs/Index.vue'
  import { useTabStore, useAuthStore } from '@jms/store'
  import { lang } from '@jms/utils'

  defineProps({
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  })

  const { VITE_APP_ENV } = import.meta.env
  const tabStore = useTabStore()
  const authStore = useAuthStore()
  const keepAliveComponentNames = computed(() => tabStore.getTabs.map((_) => _.name))
  const watermarkContent = computed(() => {
    const userInfo = authStore.userInfo
    const accountLevel = (userInfo as any)?.accountLevel?.code
    if (!['0', '1'].includes(accountLevel)) return ''
    const userName = (userInfo as any)?.userName || (userInfo as any)?.userAccount || ''
    if (!userName) return ''
    return `${userName}${dayjs().format('YYYY-MM-DD')}`
  })
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
